import React from "react";
import classNames from "classnames";
import { WebAppContext } from "./WAContainer";
import { MenuBurgerIcon } from "../Icon/Icon";
export function WAHeaderToggle() {
  let state = WebAppContext.useContainer();
  return (
    <div className="wa-header-toggle">
      <button
        onClick={() => state.setOpen(!state.open)}
        className={classNames("navbar-toggler", { show: state.open })}
      >
        <MenuBurgerIcon></MenuBurgerIcon>
      </button>
    </div>
  );
}
